import HyperlinkPhoneNumber from "@/components/functionals/HyperlinkPhoneNumber.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ReportTerminalsHyperLink from "@/components/functionals/ReportTermianlsHyperLink.vue";

export async function GetClientsWitoutApp(thiss) {
  let Parameters = {
    params: {
      /*
        CompanyCode: thiss.currentCompany,
        SellerCode: thiss.currentUser.PersonCode,
        CustomerServicesCode: thiss.currentUser.CustomerServiceExec_, //!= null ? thiss.currentUser.CustomerServiceExec_ : 0,
        EmployeeId: thiss.currentUser.EmployeeId,
        UserId: thiss.currentUser.UserID,
        */
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      optionStr: "app"
    }
  };
  let customerService = thiss.currentUser.CustomerServiceExec_;
  let isSupervisor = thiss.currentUser.IsSupervisor;
  let TableData = [];

  if (
    //thiss.currentUser.Roles.some((e) => e.Id === 37 || e.Id === 25)
    thiss.currentUser.PositionID == 52 ||
    thiss.currentUser.PositionID == 74 ||
    thiss.currentUser.PositionID == 16
  ) {
    await thiss.$http
      .get("/api/MessageApi/GetExcutiveStatDetails", Parameters)
      .then((response) => {
        //console.log("data clients without app: " , response)
        let data = response.data[0].ClientWithOrWithoutApps;
        //console.log("resivi la llamad es esta: ", data);
        let ClienteArray = [];

        data.forEach((cliente) => {
          let usoapp = Boolean;

          let TotalContacts = cliente.ContactsWithOrWithoutApp;

          let ContactsWithApp = cliente.ContactsWithOrWithoutApp.filter(
            (Contact) => Contact.LoginQTY > 0
          );

          let ContactsWithoutApp = cliente.ContactsWithOrWithoutApp.filter(
            (Contact) => Contact.LoginQTY <= 0
          );

          let ContactPortalWebActive = cliente.ContactsWithOrWithoutApp.filter(
            (Contact) =>
              Contact.EstadoProtalWeb > 0 && Contact.EstadoProtalWeb != null
          );

          let ContactPortalWebInactive =
            cliente.ContactsWithOrWithoutApp.filter(
              (Contact) =>
                Contact.EstadoProtalWeb == null || Contact.EstadoProtalWeb == 0
            );

          ContactPortalWebInactive.forEach((contact) => {
            if (contact.ContactPortalWebInactive == null) {
              contact.ContactPortalWebInactive = 0;
            }
          });

          if (cliente.LoginQTY > 0) {
            usoapp = true;
          } else {
            usoapp = false;
          }
          ClienteArray.push({
            UsoApp: usoapp,
            TotalContacts: TotalContacts,
            CantTotalContacts: TotalContacts.length,
            ContactsWithApp: ContactsWithApp,
            ContactsWithoutApp: ContactsWithoutApp,
            CantContactsWithApp: ContactsWithApp.length,
            CantContactsWithoutApp: ContactsWithoutApp.length,
            ContactPortalWebActive: ContactPortalWebActive,
            ContactPortalWebInactive: ContactPortalWebInactive,
            CantContactPortalWebActive: ContactPortalWebActive.length,
            CantContactPortalWebInactive: ContactPortalWebInactive.length,
            ...cliente
          });
        });

        if (customerService === null || isSupervisor === true) {
          TableData = CopyData(
            ClienteArray.filter(
              (client) =>
                client.CantContactsWithApp === 0 ||
                client.CantContactsWithoutApp > 0
            )
          );
        } else {
          TableData = CopyData(
            ClienteArray.filter(
              (client) =>
                client.CustomerServiceCode === customerService &&
                (client.CantContactsWithApp === 0 ||
                  client.CantContactsWithoutApp > 0)
            )
          );
        }

        //console.log("TableData: ", TableData, "\nClienteArray: ", ClienteArray);
        //self.Resultado = ClienteArray;
      });
  } else {
    TableData = [];
  }
  return TableData;
}

export const AppColumns = (thiss) => [
  {
    prop: "CustomerCode",
    label: "Codigo Clinte",
    width: 150,
    align: "center",
    fixed: true,
    sortable: true
  },
  {
    prop: "CustomerName",
    label: "Nombre del Clinte",
    width: 350,
    sortable: true
  },
  {
    prop: "CustomerPhone",
    label: "Teléfono del Clinte",
    width: 170,
    sortable: true,
    formatter: HyperlinkPhoneNumber
  },
  {
    prop: "CustomerServiceName",
    label: "Servicio al Cliente",
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "CustomerServiceImage"
    },
    width: 160
  },
  {
    prop: "SalesPersonName",
    label: "Vendedor",
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "SalesPersonImage"
    },
    width: 190
  },
  {
    prop: "CantTotalContacts",
    label: "Total Contactos",
    sortable: true,
    width: 170,
    align: "center",
    cellAtrrs: {
      OpenTerminalsDetail: thiss.OpenContactsDetail
    },
    formatter: ReportTerminalsHyperLink
    //formatter: ColorTagsinLineFormatter
  },

  {
    prop: "CantContactsWithApp",
    label: "Contactos con App",
    sortable: true,
    width: 170,
    align: "center",
    cellAtrrs: {
      OpenTerminalsDetail: thiss.OpenContactsDetail
    },
    formatter: ReportTerminalsHyperLink
    //formatter: ColorTagsinLineFormatter
  }
  /*
    {
      prop: "CantContactPortalWebActive",
      label: "Activo en el Portal",
      sortable: true,
      width: 170,
      align: "center",
      cellAtrrs: {
        OpenTerminalsDetail: thiss.OpenContactsDetail
      },
      formatter: ReportTerminalsHyperLink
      //formatter: ColorTagsinLineFormatter
    }
    */
];

export const AppActions = [
  /*
    {
      label: "Crear solicitud de soporte",
      icon: "",
      command: "create_support_request"
    },
    */
  {
    label: "Crear una interaccion al cleinte",
    icon: "",
    command: "create_client_iteration_from_PortalAPP"
  }
  /*
  {
    label: "Excluir cliente del reporte",
    icon: "",
    command: "client_report_exclude"
  }
  */
];

function CopyData(ClienteArray) {
  return ClienteArray;
}
